import { Text as Paragraph } from "@/components/podkit/typography/Text";
import { cva, type VariantProps } from "class-variance-authority";
import { type FC, type ReactNode } from "react";

const featureItemIconVariants = cva("flex h-6 w-6 shrink-0 items-center justify-center rounded-lg", {
    variants: {
        variant: {
            success: "bg-surface-success-subtle text-content-success",
            warning: "bg-surface-warning-subtle text-content-warning",
            destructive: "bg-surface-destructive-subtle text-content-destructive",
            brand: "bg-surface-brand-subtle text-content-brand",
            "brand-purple": "bg-surface-brand-accent-01 text-content-brand-accent-01",
        },
    },
    defaultVariants: {
        variant: "brand",
    },
});

export type FeatureItemVariant = VariantProps<typeof featureItemIconVariants>["variant"];

export type FeatureItemProps = {
    icon: ReactNode;
    variant?: FeatureItemVariant;
    title: string;
    description: string;
};

export const FeatureItem: FC<FeatureItemProps> = ({ icon, variant, title, description }) => {
    return (
        <div className="flex gap-3 rounded-xl border border-border-subtle bg-surface-popover p-4">
            <div className={featureItemIconVariants({ variant })}>
                {icon}
            </div>
            <div className="flex flex-col gap-0.5">
                <Paragraph className="text-base font-medium text-content-primary">{title}</Paragraph>
                <Paragraph className="text-sm text-content-secondary">{description}</Paragraph>
            </div>
        </div>
    );
};
